import { getSinglePostData } from "../api"
import { toastError, toastWarn } from "../../../modules/global/errors.toast";
import {
    GET_SINGLEPOST_REQUEST,
    GET_SINGLEPOST_SUCCESS,
    GET_SINGLEPOST_FAILURE,
} from "../const";



const request = () => ({ type: GET_SINGLEPOST_REQUEST });

const success = (OnePost, empty) => ({
    type: GET_SINGLEPOST_SUCCESS,
    payload: { OnePost, empty },
});
const failure = () => ({ type: GET_SINGLEPOST_FAILURE });

export const receiveSinglePost = (params) => async (dispatch) => {
    dispatch(request());
    try {
        getSinglePostData(params).then(({ data: receiveOnePostData }) => {
            const is_empty = () => {
                return receiveOnePostData.length === 0 ? true : false;
            }
            dispatch(success(receiveOnePostData, is_empty()));
        }).catch((error) => {
            if (error.response.status === 400) {
                toastWarn(`${error.response.status} Bad request`)
            } else {
                if (error.response.status === 500) {
                    toastError(`${error.response.status} Server error`)
                }
            }
        })

    } catch (e) {
        dispatch(failure());
    };
};